import moment from "../../moment";

export const getIntervalLimit = (masterSheet, sheet) => {
  console.log("intervalLimit :>> start");

  // 最後にシートを使った時間＋インターバルの時間を足した時間
  let intervalLimit;
  const useInterval = masterSheet.use_interval.replace(/[^0-9]/g, "");
  const lastUsedAt = moment(new Date(sheet.last_used_at));

  switch (masterSheet.use_interval.replace(useInterval, "")) {
    case "minutes":
      intervalLimit = lastUsedAt.add(useInterval, "m");
      break;
    case "hours":
      intervalLimit = lastUsedAt.add(useInterval, "h");
      break;
    case "days":
      intervalLimit = lastUsedAt.add(useInterval, "d");
      break;
  }
  console.log("intervalLimit :>> ", intervalLimit);
  return intervalLimit;
};
